import React from "react";

import { getBoatBodyMaterial } from "../../../../redux/directoryMaintenance/boatBodyMaterialReducer/actionsBoatBodyMaterial";

import BoatBodyMaterialModal from "./boatBodyMaterialModal/boatBodyMaterialModal";
import GeneralSectionComponent from "../generalSectionComponent";

import { BOAT_BODY_MATERIAL_COLUMNS } from "../../../../components/GeneralComponents/SearchTable/TablesColumns";

function BoatBodyMaterial() {
  return (
    <GeneralSectionComponent
      title={"Материалы корпуса маломерного судна"}
      headerColumns={BOAT_BODY_MATERIAL_COLUMNS}
      dataFromStateSelector={(state) =>
        state.dictionaryReducer.allBoatBodyMaterial
      }
      getAction={getBoatBodyMaterial}
      ModalComponent={BoatBodyMaterialModal}
    />
  );
}

export default BoatBodyMaterial;
